import React from 'react'
import styled from '@emotion/styled'
import type { FobSelection } from '@mobi/betslip/types'
import { isFobDetails, isRaceDetails } from '@mobi/betslip/helpers/typeGuards'
import { Flex } from '@mobi/component-library/Misc/Flex'
import { colors, spacing } from '@mobi/component-library/Foundations'
import type { QuickbetState } from '@core/Areas/Quickbet/driver'
import { SecondaryInfo } from '../Common/SecondaryInfo'
import { SelectionOverflow } from '../Common/SelectionOverflow'
import { RacingHeader } from './Components/RacingHeader'
import { FobHeader } from './Components/FobHeader'

export const MultiHeader: React.FC<{ legs: NonNullable<QuickbetState['selectionMultiLegs']> }> = ({
  legs,
}) => {
  return (
    <WrapperStyled>
      <SecondaryInfo marketInfo={`${legs.length} Leg Multi`} />

      <SelectionOverflow shouldRestrictHeight={legs.length > 3}>
        <Flex flexDirection='column' gap='1rem'>
          {legs.map(item => (
            <React.Fragment key={item.id}>
              {isRaceDetails(item.selectionDetails) ? (
                <RacingHeader
                  key={item.id}
                  selection={item.selection}
                  races={item.selectionDetails.races}
                  acceptors={item.selectionDetails.acceptors}
                  betLegType={item.multiLegBetType}
                />
              ) : isFobDetails(item.selectionDetails) ? (
                <FobHeader
                  selectionDetails={item.selectionDetails}
                  betLegType={item.multiLegBetType}
                  legOdds={
                    item.multiLegBetType === 'W'
                      ? (item.selection as FobSelection).winPrice
                      : (item.selection as FobSelection).placePrice
                  }
                />
              ) : null}

              <div className='multi-info__divider' />
            </React.Fragment>
          ))}
        </Flex>
      </SelectionOverflow>
    </WrapperStyled>
  )
}

// ======
// Styles
// ======

const WrapperStyled = styled.div({
  display: 'flex',
  flexDirection: 'column',
  gap: spacing.sm,
  paddingBottom: spacing.smx2,

  '.multi-info__divider': {
    height: '1px',
    width: '100%',
    backgroundColor: colors.studio[600],

    '&:last-of-type': { display: 'none' },
  },
})
